<div class="p-3">
  <h2>Mentee rating - Final</h2>
  <p class="text-xs">Check rating of each mentee</p>
</div>
<div class="container-iframe">
  <iframe [src]="url" class="responsive-iframe"></iframe>
</div>
